<script setup lang="ts">

import { Pagination } from '@/components/ui/pagination'
import { PaginationList, PaginationListItem, PaginationPrev } from 'reka-ui'
import '@/assets/scss/pagination.scss'

const props = defineProps({
  pageSize: {
    type: Number,
    default: 1
  },
  total: {
    type: Number,
    default: 0
  },
  siblingCount: {
    type: Number,
    default: 3
  },
  defaultPage: {
    type: Number,
    default: 1
  }
})

const emit = defineEmits(['page-changed'])

const handleChangePage = (value: number) => {
  emit('page-changed', value)
}

</script>

<template>
  <div class="dash-pagination">
  <Pagination v-slot="{ page }"
              :items-per-page="props.pageSize"
              :total="props.total"
              :sibling-count="props.siblingCount" show-edges
              :default-page="props.defaultPage">
    <PaginationList v-slot="{ items }" class="flex items-center gap-1">
      <template v-for="(item, index) in items">
        <PaginationListItem v-if="item.type === 'page'" :key="index" :value="item.value" as-child>
          <button :class="item.value === page ? 'active' : ''" @click="()=>handleChangePage(item.value)">
            {{ item.value }}
          </button>
        </PaginationListItem>
        <PaginationEllipsis v-else :key="item.type" :index="index"> ... </PaginationEllipsis>
      </template>
    </PaginationList>
  </Pagination>
  </div>
</template>
